import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { BrowserView, MobileView, isTablet } from 'react-device-detect';
import SpeakingPractice from "../../components/speakingpractice/SpeakingPractice";
import PlayRecordSP from "../../components/speakingpractice/PlayRecordSP";
import Congratulations from "../../components/congratulations/Congratulations";
import CheckUp from "../../components/feedback/CheckUp";
import Feedback from "../../components/feedback/Feedback";
import Guide from "../../components/guide/Guide";
import CloseActivityModal from "../../components/modal/CloseActivityModal";
import RecordTimeOverModal from "../../components/modal/RecordTimeOverModal";
import AlertModal from "../../components/modal/AlertModal";
import SpeakingPracticeResult from "../../components/result/SpeakingPracticeResult";
import CancelIcon from "../../images/activity-sitcom/cancel-icon.png";
import HelpIcon from "../../images/activity-sitcom/help-icon.png";
import * as userStore from '../../modules/userStore';
import API from "../../shared/api";
import cachebusting from "../../const/cachebusting";

import "../../css/layout.css";
import "../../css/speakingpractice.css";

// click_sound
import click_sound from "../../audios/click_sound.mp3";
import ActHeader from "../../components/layouts/ActHeader";

import { useAudio } from "../../shared/hooks";
import {convertToS3Url} from "../../util/url";

const SpeakingBoosterBlock = styled.div`

.contents {
  .route_bar {
    background-color: #08bbcb;
    .paging{
      background-color:#9dc3e6;
    }
    }
  }
  .screen{
    position:relative;
    >.buttonGroup{
      position:absolute;
      left:50%;
      bottom:60px;
      transform:translateX(-50%);
      width:auto;
      height:auto;
      img{
        width:206px;
        height:79px;
        margin-right:10px;
        cursor:pointer;
        :last-child{
          margin-right:0;
        }
      }
    }
  }
}
.konvajs-content {
  margin: auto;
}
@media (max-width: 1024px), (max-height: 768px) {
  .screen{
    >.buttonGroup{
      bottom:40px;
      img{
        width: 190px;
        height: 70px;
      }
    }
  }
}
/*태블릿 7인치 이하*/
@media (max-height: 650px) {
  .screen{
    >.buttonGroup{
      min-width:300px;
      bottom:30px;
      img{
        width: 160px;
        height: 60px;
      }
    }
  }
`

const Index = () => {
  const { play } = useAudio()
  let location = useLocation();
  let history = useHistory();
  const userSelector = useSelector(store => store.userStore);
  const dispatch = useDispatch();
  const miniSitcomRef = useRef();

  const episodeInfo = userSelector.info.episodes.find(item => item.episodeId === location.state.episodeId);
  const lessonInfo = episodeInfo.lessons.find(item => item.lessonId === location.state.lessonId);
  const actInfo = lessonInfo.acts.find(item => item.actId === location.state.actId);

  const [orgActList, setOrgActList] = useState([]);
  const [actList, setActList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [categorySelected, setCategorySelected] = useState({});

  const [setNum, setSetNum] = useState(1);
  const [maxSetNum, setMaxSetNum] = useState(1);
  const [minCategoryNum, setMinCategoryNum] = useState(0);
  const [maxCategoryNum, setMaxCategoryNum] = useState(1);

  const speakingpracticeRef = useRef();

  const playrecordRef = useRef();

  const isRecording = React.useRef(false);
  const handleIsRecordingChange = (isRecordingLocal) => {
    isRecording.current = isRecordingLocal;
  }
  const answerOpen = (recordingIndex) => {
    playrecordRef.current.answerOpen(recordingIndex);
  };
  const answerClose = () => {
    playrecordRef.current.answerClose();
  };

  const handleGuide = () => {
    setGuideFinished(false);
  };

  // let clickAudio = new Audio(click_sound);


  const nextButtonRef = useRef();

  const setNextButtonEnabledR = () => {
    if (btnNextRef.current) return;


    if (categorySelected.sentence) {
      let errorIndex = -1;

      if (errorIndex > -1) {

      } else {
        nextButtonRef.current.children[0].src = btnNext[1];
        nextButtonRef.current.className = 'right-button';
        nextButtonRef.current.onmouseenter = () => { nextButtonRef.current.src = btnNext[0]; };
        nextButtonRef.current.onmouseleave = () => { nextButtonRef.current.src = btnNext[1]; };
        nextButtonRef.current.onmousedown = () => { nextButtonRef.current.src = btnNext[2]; };
        nextButtonRef.current.ontouchstart = () => { nextButtonRef.current.src = btnNext[2]; };
        // 종료 팝업 미리 뜨는 오류로 인해 기존 nextCategoryR에서 nextCategory로 변경
        // nextButtonRef.current.onmouseup = () => { nextButtonRef.current.src = btnNext[1]; clickAudio.play(); nextCategoryR(); };
        // nextButtonRef.current.ontouchend = () => { nextButtonRef.current.src = btnNext[1]; clickAudio.play(); nextCategoryR(); };

        // 수정함
        nextButtonRef.current.onmouseup = () => { nextButtonRef.current.src = btnNext[1]; play(click_sound); nextCategory(); };
        nextButtonRef.current.ontouchend = () => { nextButtonRef.current.src = btnNext[1]; play(click_sound); nextCategory(); };
      }
    } else {

    }

  };
  const setNextButtonEnabled = () => {
    if (btnNextRef.current) return;


    if (categorySelected.sentence) {
      let errorIndex = -1;
      for (var index = 0; index < categorySelected.sentence.length; index++) {
        let sentence = categorySelected.sentence[index];
        // 녹음 완료해야 화살표 기능 활성화되는 것 주석 처리
        // if (sentence.audio && 'Y' == sentence.record && ((!sentence.file || !sentence.file.size || sentence.file.size < 0) && !sentence.fileUrlPath)) {
        //   errorIndex = index;
        //   break;
        // }
      }

      if (errorIndex > -1) {

      } else {
        console.log('여기');
        nextButtonRef.current.children[0].src = btnNext[1];
        nextButtonRef.current.className = 'right-button';
        nextButtonRef.current.onmouseenter = () => { nextButtonRef.current.src = btnNext[0]; };
        nextButtonRef.current.onmouseleave = () => { nextButtonRef.current.src = btnNext[1]; };
        nextButtonRef.current.onmousedown = () => { nextButtonRef.current.src = btnNext[2]; };
        nextButtonRef.current.ontouchstart = () => { nextButtonRef.current.src = btnNext[2]; };

        // 수정함
        nextButtonRef.current.onmouseup = () => { nextButtonRef.current.src = btnNext[1]; play(click_sound); nextCategory(); };
        nextButtonRef.current.ontouchend = () => { nextButtonRef.current.src = btnNext[1]; play(click_sound); nextCategory(); };
      }
    } else {

    }

  };



  const pagenum = parseInt(setNum, 10) || 1; // (setNum && setNum === actListRow.set

  let minRecordCategoryNum = 1;
  console.log('actInfo', actInfo);
  useEffect(() => {

    const fetchData = async (actContentData) => {
      console.log('actContentData', actContentData);
      let filePathReplaced = convertToS3Url(actInfo.file_path);
      
      await fetch(filePathReplaced + cachebusting)
        .then(res => res.json())
        .then(res => {
          // 수정함
          console.log("-=-=-=-=-=-=-res", res);
          setOrgActList(res);
          // setOrgActList(JSON.parse(JSON.stringify()));

          try {
            const stdAnswer = JSON.parse(actContentData.stdAnswer);

            res.map((res_item, res_index) => {
              res_item.category.map((category_item, category_index) => {
                if (category_item.name === 'Expended Sentence') {
                  category_item.sentence.map((sentence_item, sentence_index) => {
                    if (sentence_item.quiz) {
                      sentence_item.quiz.list.map((quizList_item, quizList_index) => {
                        if (stdAnswer && stdAnswer.length > res_index &&
                          stdAnswer[res_index].category && stdAnswer[res_index].category.length > category_index &&
                          stdAnswer[res_index].category[category_index].sentence && stdAnswer[res_index].category[category_index].sentence.length > sentence_index &&
                          stdAnswer[res_index].category[category_index].sentence[sentence_index].quiz.list && stdAnswer[res_index].category[category_index].sentence[sentence_index].quiz.list.length > quizList_index) {
                          var choiceSelected = stdAnswer[res_index].category[category_index].sentence[sentence_index].quiz.list[quizList_index].choiceSelected;
                          if (choiceSelected) {
                            quizList_item.choiceSelected = choiceSelected;
                          }
                        }
                      });
                    }
                    if (stdAnswer && stdAnswer.length > res_index &&
                      stdAnswer[res_index].category && stdAnswer[res_index].category.length > category_index &&
                      stdAnswer[res_index].category[category_index].sentence && stdAnswer[res_index].category[category_index].sentence.length > sentence_index) {
                      var fileUrlPath = stdAnswer[res_index].category[category_index].sentence[sentence_index].fileUrlPath;
                      if (fileUrlPath) {
                        sentence_item.fileUrlPath = fileUrlPath;

                        var player = new Audio(fileUrlPath);
                        if (player) {
                          sentence_item.player = player;
                        }
                      }
                    }
                  });
                }
              });
            });
          } catch (error) {
            console.log('Incorrect student answer data, ', error);
          }

          setActList(res);

          const maxSetNum = res.sort((a, b) => a.set - b.set)[res.length - 1].set;
          setMaxSetNum(maxSetNum);

          const categoryList = res.find(item => item.set === setNum).category;
          setCategoryList(categoryList);

          categoryList.sort((a, b) => a.order - b.order).forEach((value, index) => {
            if (index === 0) {
              setMinCategoryNum(value.order);
              setCategorySelected(categoryList[value.order]);
            } else if (index === categoryList.length - 1) {
              setMaxCategoryNum(value.order);
            }
          });

          // if (actContentData && actContentData.actCurrentPage) {
          //   setSetNum(actContentData.actCurrentPage);
          // }
        });
    };

    async function callApiAct() {
      const data = await API('get', 'act', {
        product: userSelector.info.productId,
        courseId: userSelector.info.courseId,
        bookId: userSelector.info.bookId,
        episodeCode: episodeInfo.episodeCode,
        lessonId: lessonInfo.lessonId,
        actId: actInfo.actId
      }, {
        studentId: userSelector.info.studentId,
        oCode: userSelector.info.oCode
      }).catch((error) => {
        console.error(error);
      });

      fetchData(data ? data.actContentData : data);
    }
    callApiAct();
  }, []);

  const [guideFinished, setGuideFinished] = useState(false);

  const closeActivityModalRef = useRef();
  const handleClose = () => {
    closeActivityModalRef.current.openModal();
  }

  const recordTimeOverModalRef = useRef();
  const alertModalRef = useRef();
  const openAlertModal = (text) => {
    if (setNum === 1 && categorySelected.order === minRecordCategoryNum) {
      alertModalRef.current.openModal(text);
      setTimeout(() => { alertModalRef.current.closeModal(); }, 4000);
    }
  };

  const feedbackRef = useRef();
  const feedback = (isTrue) => {
    feedbackRef.current.feedback(isTrue);
  }

  const prevCategory = () => {
    answerClose();
    if (categorySelected.order > minCategoryNum) {
      setCategorySelected(categoryList[categorySelected.order - 1]);
    }
  };

  const nextCategory = () => {
    console.log('0');
    answerClose();
    if (categorySelected.name === "Main Sentence") {
      if (categorySelected.order < maxCategoryNum) {
        setCategorySelected(categoryList[categorySelected.order + 1]);
      }
    } else {
      console.log('data_categorySelected.sentence', categorySelected.sentence);

      let newRecordExists = false;
      categorySelected.sentence.forEach(item => {
        if (item.file && item.file.size && item.file.size > 0) {
          newRecordExists = true;
          return false;
        }
      });
      console.log('data_newRecordExists', newRecordExists);

      if (newRecordExists) {
        /**
         * 학생 Act 학습 정보 저장 API
         * https://dcon-api.eggschool.net/api-docs/#/DCON%20Act%20%ED%95%99%EC%8A%B5%20%EC%97%B0%EB%8F%99%20API/Save
         */
        async function callApiAct() {
          const data = await API('post', 'act', {}, {
            oCode: userSelector.info.oCode,
            productId: userSelector.info.productId,
            studentId: userSelector.info.studentId,
            courseId: userSelector.info.courseId,
            bookId: userSelector.info.bookId,
            level: actInfo.level,
            episodeId: episodeInfo.episodeId,
            episodeCode: episodeInfo.episodeCode,
            lessonId: lessonInfo.lessonId,
            actId: actInfo.actId,
            actType: actInfo.actType,
            actStatus: (actInfo.actStatus === 'Ready' ? 'Progress' : actInfo.actStatus),
            actPoint: 0,
            actCurrentPage: setNum,
            question: JSON.stringify(orgActList),
            answer: JSON.stringify(actList)
          }).catch((error) => {
            console.error(error);
          });

          console.log(data);

          userSelector.info
            .episodes.find(item => item.episodeId === location.state.episodeId)
            .lessons.find(item => item.lessonId === location.state.lessonId)
            .acts.find(item => item.actId === location.state.actId)
            .actStatus = (actInfo.actStatus === 'Ready' ? 'Progress' : actInfo.actStatus);

          dispatch(userStore.save(userSelector.info));

          let nextCategory;
          if (categorySelected.order  < maxCategoryNum) {
            nextCategory = categoryList[categorySelected.order + 1];
          } else {
            nextCategory = {
              ...categoryList[1],
              name: 'result',
              first: true,
            };
          }
          setCategorySelected(nextCategory);
        }

        /**
         * 학생 파일 파일 업로드 API
         * https://dcon-api.eggschool.net/api-docs/#/DCON%20Act%20%ED%95%99%EC%8A%B5%20%EC%97%B0%EB%8F%99%20API/Upload
         */
        async function callApiActFile() {
          let index = 0;
          for (const item of categorySelected.sentence) {
            if (item.file && item.file.size && item.file.size > 0) {
              let form = new FormData();
              form.append('file', item.file);
              form.append('data', JSON.stringify({
                productId: userSelector.info.productId,
                studentId: userSelector.info.studentId,
                courseId: userSelector.info.courseId,
                bookId: userSelector.info.bookId,
                episodeId: episodeInfo.episodeId,
                lessonId: lessonInfo.lessonId,
                actId: actInfo.actId,
                actType: actInfo.actType,
                actPage: setNum,
                studentSoundNo: index + 1
              }));

              const data = await API('post', 'act/file', {}, form).catch((error) => {
                console.error(error);
              });

              console.log("==========================");
              console.log("학생 파일 파일 업로드이 완료 되었습니다.");
              console.log(data);
              console.log("==========================");

              if (!data.data || !data.data.fileUrlPath) {
                console.error("==========================");
                console.error("녹음 파일 경로 반환이 되지 않았습니다.");
                console.error("==========================");
              }

              categorySelected.sentence[index].fileUrlPath = data.data.fileUrlPath;
            }
            index++;
          }
          callApiAct();
        }
        callApiActFile();
      } else {
        let nextCategory;
        if (categorySelected.order < maxCategoryNum) {
          nextCategory = categoryList[categorySelected.order + 1];
        } else {
          nextCategory = {
            ...categoryList[1],
            name: 'result',
            first: false
          };
        }
        setCategorySelected(nextCategory);
      }
    }
  };

  const nextCategoryR = () => {
    answerClose();
    let nextCategory;
    if (categorySelected.order < maxCategoryNum) {
      nextCategory = categoryList[categorySelected.order + 1];
    } else {
      nextCategory = {
            name: 'finished',
            order: categorySelected.order,
          };
    }
    setCategorySelected(nextCategory);

  };

  const btnPrevRef = useRef();
  const btnNextRef = useRef();
  const btnPre = [
    require('../../images/activity-button/btn_pre_h.png').default,
    require('../../images/activity-button/btn_pre_n.png').default,
    require('../../images/activity-button/btn_pre_p.png').default,
    require('../../images/activity-button/btn_pre_d.png').default,
  ];
  const btnNext = [
    require('../../images/activity-button/btn_next_h.png').default,
    require('../../images/activity-button/btn_next_n.png').default,
    require('../../images/activity-button/btn_next_p.png').default,
    require('../../images/activity-button/btn_next_d.png').default,
  ];

  const RenderActivityArea = () => {
    if (!guideFinished) {
      return <Guide setGuideFinished={setGuideFinished} />
    } else {
      if (categorySelected.name === 'finished') {
        return (
          <div className="box d-flex justify-content-center align-items-center">
            <Congratulations categorySelected={categorySelected} />
          </div>
        );
      } else if (categorySelected.name === 'result') {
        const btnAgain = [
          require('../../images/common/btn_again_h.png').default,
          require('../../images/common/btn_again_n.png').default,
          require('../../images/common/btn_again_p.png').default,
        ];
        const btnNext = [
          require('../../images/common/btn_next_h.png').default,
          require('../../images/common/btn_next_n.png').default,
          require('../../images/common/btn_next_p.png').default,
        ];

        const LoadBtn = (props) => {
          const btnEvents = (e) => {
            let btns;
            if (btnAgain.findIndex(item => item === e.target.src) > -1) {
              btns = btnAgain;
            } else if (btnNext.findIndex(item => item === e.target.src) > -1) {
              btns = btnNext;
            } else {
              return;
            }

            if (e.type === "mouseover") {
              e.target.src = btns[0];
            } else if (e.type === "mouseleave") {
              e.target.src = btns[1];
            } else if (e.type === "mousedown" || e.type === "touchstart") {
              e.target.src = btns[2];
            } else if (e.type === "mouseup" || e.type === "touchend") {
              e.target.src = btns[0];

              if (btns === btnAgain) {
                // try again하면 sitcom dialogue로 가도록 수정
                setCategorySelected(categoryList[0]);
              } else if (btns === btnNext) {
                if (categorySelected.order < maxCategoryNum) {
                  let nextCategory = {
                    ...categoryList[categorySelected.order + 1],
                    name: 'result',
                  };
                  setCategorySelected(nextCategory);
                } else {
                  if (setNum === maxSetNum) {
                    /**
                     * 학생 Act 학습 정보 저장 API
                     * https://dcon-api.eggschool.net/api-docs/#/DCON%20Act%20%ED%95%99%EC%8A%B5%20%EC%97%B0%EB%8F%99%20API/Save
                     */
                    async function callApiAct() {
                      if (actInfo.actStatus !== 'Completed') {
                        const data = await API('post', 'act', {}, {
                          oCode: userSelector.info.oCode,
                          productId: userSelector.info.productId,
                          studentId: userSelector.info.studentId,
                          courseId: userSelector.info.courseId,
                          bookId: userSelector.info.bookId,
                          level: actInfo.level,
                          episodeId: episodeInfo.episodeId,
                          episodeCode: episodeInfo.episodeCode,
                          lessonId: lessonInfo.lessonId,
                          actId: actInfo.actId,
                          actType: actInfo.actType,
                          actStatus: "Completed",
                          actPoint: actInfo.actCompletPoint,
                          actCurrentPage: setNum,
                          question: JSON.stringify(orgActList),
                          answer: JSON.stringify(actList)
                        }).catch((error) => {
                          console.error(error);
                        });

                        userSelector.info
                          .episodes.find(item => item.episodeId === location.state.episodeId)
                          .lessons.find(item => item.lessonId === location.state.lessonId)
                          .acts.find(item => item.actId === location.state.actId)
                          .actStatus = "Completed";
                        userSelector.info
                          .episodes.find(item => item.episodeId === location.state.episodeId)
                          .lessons.find(item => item.lessonId === location.state.lessonId)
                          .acts.find(item => item.actId === location.state.actId)
                          .file = categorySelected.file;
                        userSelector.info
                          .episodes.find(item => item.episodeId === location.state.episodeId)
                          .lessons.find(item => item.lessonId === location.state.lessonId)
                          .acts.find(item => item.actId === location.state.actId)
                          .fileUrl = categorySelected.fileUrl;
                        userSelector.info
                          .episodes.find(item => item.episodeId === location.state.episodeId)
                          .lessons.find(item => item.lessonId === location.state.lessonId)
                          .acts.find(item => item.actId === location.state.actId)
                          .player = categorySelected.player;

                        dispatch(userStore.save(userSelector.info));
                      }

                      let nextCategory = {
                        name: 'finished',
                        order: categorySelected.order,
                        retry: () => {
                          setSetNum(1);
                          if (actList.length > 0) {
                            const categoryList = actList.find(item => item.set === 1).category;
                            setCategoryList(categoryList);

                            categoryList.sort((a, b) => a.order - b.order).forEach((item, index) => {
                              if (index === 0) {
                                setMinCategoryNum(item.order);
                                setCategorySelected(categoryList[item.order]);
                              } else if (index === categoryList.length - 1) {
                                setMaxCategoryNum(item.order);
                              }
                            });
                          }
                        },
                      };
                      setCategorySelected(nextCategory);
                    }
                    callApiAct();
                  } else {
                    setSetNum(setNum + 1);
                    if (actList.length > 0) {
                      const categoryList = actList.find(item => item.set === setNum + 1).category;
                      setCategoryList(categoryList);

                      categoryList.sort((a, b) => a.order - b.order).forEach((item, index) => {
                        if (index === 0) {
                          setMinCategoryNum(item.order);
                          setCategorySelected(categoryList[item.order]);
                        } else if (index === categoryList.length - 1) {
                          setMaxCategoryNum(item.order);
                        }
                      });
                    }
                  }
                }
              }
            }
          };

          return (
            <img src={props.src} alt=""
              onMouseOver={btnEvents}
              onMouseLeave={btnEvents}
              onMouseDown={btnEvents}
              onTouchStart={btnEvents}
              onMouseUp={btnEvents}
              onTouchEnd={btnEvents} />
          )
        };

        const nextCategoryAtResult = () => {
          if (categorySelected.order < maxCategoryNum) {
            let nextCategory = {
              ...categoryList[categorySelected.order + 1],
              name: 'result',
            };
            setCategorySelected(nextCategory);
          }
        };

        return (
          <div className="box-wrap">
            <div className="practice-box">
              <div className="box d-flex justify-content-center align-items-center">
                <div className="screen">
                  <div>
                    <SpeakingPracticeResult
                      categorySelected={categorySelected}
                      nextCategoryAtResult={nextCategoryAtResult}
                      mediaPath={actInfo.media_path}
                    />
                  </div>
                  <div className="buttonGroup">
                    <LoadBtn src={btnAgain[1]} />
                    <LoadBtn src={btnNext[1]} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="box-wrap">
            <div className="practice-box">
              <div className="box d-flex justify-content-center align-items-center">
                <div className="screen">
                  <div>
                    <SpeakingPractice
                      ref={miniSitcomRef}
                      categorySelected={categorySelected}
                      setNextButtonEnabled={setNextButtonEnabled}
                      mediaPath={actInfo.media_path}
                      feedback={feedback}
                      setNextButtonEnabledR={setNextButtonEnabledR}
                      openAlertModal={openAlertModal}
                      recordTimeOverModalRef={recordTimeOverModalRef}
                      answerOpen={answerOpen}
                      pagenum={pagenum}
                      isRecording={isRecording}
                    />
                  </div>
                </div>

              </div>
              {
                categorySelected.order > minCategoryNum &&
                <div className="left-button"
                  onMouseEnter={() => { btnPrevRef.current.src = btnPre[0]; }}
                  onMouseLeave={() => { btnPrevRef.current.src = btnPre[1]; }}
                  onMouseDown={() => { btnPrevRef.current.src = btnPre[2]; }}
                  onTouchStart={() => { btnPrevRef.current.src = btnPre[2]; }}
                  onMouseUp={() => { btnPrevRef.current.src = btnPre[1]; prevCategory(); }}
                  onTouchEnd={() => { btnPrevRef.current.src = btnPre[1]; prevCategory(); }}
                >
                  <img src={btnPre[1]} alt="" ref={btnPrevRef} />
                </div>
              }
              {
                categorySelected.name === "Main Sentence" || actInfo.actStatus === 'Completed' ?
                  <>
                    <BrowserView>
                      <div className="right-button"
                        // style={{ border: '1px solid red'}}
                        onMouseEnter={() => { btnNextRef.current.src = btnNext[0]; }}
                        onMouseLeave={() => { btnNextRef.current.src = btnNext[1]; }}
                        onMouseDown={() => { btnNextRef.current.src = btnNext[2]; }}
                        // 수정함
                        onMouseUp={() => { btnNextRef.current.src = btnNext[1]; play(click_sound); nextCategory(); }}
                      >
                        <img src={btnNext[1]} alt="" ref={btnNextRef} />
                      </div>
                    </BrowserView>
                    <MobileView>
                      <div className="right-button"
                        onTouchStart={() => { btnNextRef.current.src = btnNext[2]; }}
                        // 수정함
                        onTouchEnd={() => { btnNextRef.current.src = btnNext[1]; play(click_sound); nextCategory(); }}
                      >
                        <img src={btnNext[1]} alt="" ref={btnNextRef} />
                      </div>
                    </MobileView>
                  </>
                  :
                  <div className="right-button disabled" ref={nextButtonRef}>
                    <img src={btnNext[3]} alt="" />
                  </div>
              }
              {/*<div onClick={()=>nextCategoryR()}>PASS</div>*/}
            </div>
          </div>
        );
      }
    }
  };

  const checkUpRef = useRef();
  let idleSeconds = 0;
  let isIntervalRunning = true;
  // const useInterval = (callback, delay) => {
  //   const savedCallback = useRef();
  //   useEffect(() => {
  //     savedCallback.current = callback;
  //   }, [callback]);
  //   useEffect(() => {
  //     function tick() {
  //       savedCallback.current();
  //     }
  //     if (delay !== null) {
  //       let id = setInterval(tick, delay);
  //       return () => clearInterval(id);
  //     }
  //   }, [delay]);
  // };
  // useInterval(async () => {
  //   if (!isIntervalRunning) return;
  //   idleSeconds++;
  //   if (idleSeconds > (60 * 3)) {
  //     idleSeconds = 0;
  //     isIntervalRunning = false;
  //     checkUpRef.current.checkUp();
  //   }
  // }, 1000);
  const resetCheckUp = () => {
    idleSeconds = 0;
    isIntervalRunning = true;
  };

  console.log('actInfo.actStatus', actInfo.actStatus);

  const goToHome = () => {
    history.goBack();
  };

  /**
   * 녹은 완료된 문항 & 녹은 미완료된 문항 분리
   * @param setNum
   * @param actListRow
   * @returns {string}
   */
  const actNumBtnClass = (setNum, actListRow) => {
    let returnClass = "next-circle";

    if (setNum && setNum === actListRow.set) {
      returnClass = "now-circle";

    } else {
      let recodeClear = true; // 녹음 완료 여부

      actListRow.category.map((category) => {
        if (category.sentence !== undefined) {
          category.sentence.map((sentence) => {
            if (!sentence.player) {
              recodeClear = false;
            }
          });
        }
      });

      returnClass += recodeClear ? ' recodeClear' : '';
    }

    return returnClass;
  };

  return (
    <>
      <SpeakingBoosterBlock>
        <div className="practice-new">
          <div>
            <div className="contents d-flex flex-column justify-content-between">
              <CloseActivityModal ref={closeActivityModalRef} />
              <Feedback ref={feedbackRef} />
              <PlayRecordSP
                ref={playrecordRef}
                miniSitcomRef={miniSitcomRef}
                // speakingpracticeRef={speakingpracticeRef}
                feedback={feedback}
                categorySelected={categorySelected}
                setNextButtonEnabled={setNextButtonEnabled}
                setNextButtonEnabledR={setNextButtonEnabledR}
                mediaPath={actInfo.media_path}
                recordTimeOverModalRef={recordTimeOverModalRef}
                handleIsRecordingChange = {handleIsRecordingChange}
              />
              <RecordTimeOverModal ref={recordTimeOverModalRef} />
              <CheckUp ref={checkUpRef} resetCheckUp={resetCheckUp} />
              <AlertModal ref={alertModalRef} />

              <div className="route_bar d-flex align-items-center justify-content-between">
                <ActHeader episodeName={episodeInfo.episodeName} lessonTitle={lessonInfo.lessonTitle} actTitle={actInfo.actTitle}></ActHeader>
                <div className="right_icon">
                  <div className="paging">
                    <span className="current_num">0{pagenum}</span>
                    <span className="total_num">/05</span>
                  </div>
                  <img className="help_icon_img" src={HelpIcon} onClick={() => handleGuide()} alt="" />
                  <img className="cancel_icon_img" src={CancelIcon} alt="" onClick={() => handleClose()} />
                </div>
              </div>

              <div className="box_parent">
                <RenderActivityArea />
              </div>
            </div>
          </div>
        </div>
      </SpeakingBoosterBlock>
    </>
  );
};

export default Index;
